import { PROMOTION_TYPE, CALCULATE_REACH, PROMOTION_PREVIEW, PROMOTION_PAYMENT_URL, PROMOTION_LIST, PROMOTION_UPDATE, PROMOTION_DETAIL, PROMOTION_LIMIT } from './constants';
import { getAuthHeader } from "../helpers/authHelper";
import { getReq , putReq, postReq} from './rest';
import { handleResponse, loader, pageloader} from './utils';


export const promotionType = (promotionType) => {
    return {
      type: PROMOTION_TYPE,
      promotionType
    };  
};

export const fetchPromotionType = (params) => {
  
    return (dispatch, getState) => {
      const bodyFormData = new FormData();
      const headers = getAuthHeader();
      postReq(`${apiURLPrefix}/promotion/check_promotion_type`, bodyFormData , headers)
      .then(handleResponse) 
      .then((res) => {
        dispatch(promotionType(res));
      }).catch((err)=>{
        console.log(err);
      }) 
    }  
};

export const calculateReach = (calculateReach) => {
  return {
    type: CALCULATE_REACH,
    calculateReach
  };  
};

export const fetchReach = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/promotion/calculate_reach_people`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(calculateReach(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};

export const setPreview = (promotionPreview) => {
  return {
    type: PROMOTION_PREVIEW,
    promotionPreview
  };  
};

export const savePreview = (params) => {
  return (dispatch, getState) => {
    dispatch(setPreview(params));
  }  
};

export const paymentUrl = (paymentUrl) => {
  return {
    type: PROMOTION_PAYMENT_URL,
    paymentUrl
  };  
};

export const savePromotion = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/promotion/add_promotion`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(paymentUrl(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};

export const promotionList = (promotionList) => {
  return {
    type: PROMOTION_LIST,
    promotionList
  };  
};

export const listPromotion = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    
    const headers = getAuthHeader();
    loader(true);
    postReq(`${apiURLPrefix}/promotion/fetch_list`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(promotionList(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};

export const promotionUpdate = (promotionUpdate) => {
  return {
    type: PROMOTION_UPDATE,
    promotionUpdate
  };  
};

export const updatePromotion = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    Object.keys(params).map(function(key, index) {
      bodyFormData.set(key, params[key]);
    });
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/promotion/update_promotion`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      
    let resp = {
      type   : params.update_type,
      status : params.status,
      id     : params.promotion_id
    }
    dispatch(promotionUpdate(resp));
      
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};

export const promotionDetail = (promotionDetail) => {
  return {
    type: PROMOTION_DETAIL,
    promotionDetail
  };  
};

export const getPromotionDetail = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('promotion_id', params.promotion_id);
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/promotion/fetch_details`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(promotionDetail(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};

export const promotionLimit = (promotionLimit) => {
  return {
    type: PROMOTION_LIMIT,
    promotionLimit
  };  
};

export const getPromotionLimit = (params) => {
  return (dispatch, getState) => {
    const bodyFormData = new FormData();
    bodyFormData.set('goldenspace_category','PROMOTION RECENT REG');
    const headers = getAuthHeader();
    postReq(`${apiURLPrefix}/common/category_goldenspace`, bodyFormData , headers)
    .then(handleResponse) 
    .then((res) => {
      dispatch(promotionLimit(res));
    }).catch((err)=>{
      console.log(err);
    }) 
  }   
};